const expenseCategories = [
  { label: 'Product category', value: '' },
  { label: 'Transport', value: 'transport' },
  { label: 'Products', value: 'products' },
  { label: 'Health', value: 'health' },
  { label: 'Alcohol', value: 'alcohol' },
  { label: 'Entertainment', value: 'entertainment' },
  { label: 'Housing', value: 'housing' },
  { label: 'Technique', value: 'technique' },
  { label: 'Communal, communication', value: 'communal' },
  { label: 'Sports, hobbies', value: 'sports' },
  { label: 'Education', value: 'education' },
  { label: 'Other', value: 'other' },
];
export default expenseCategories;
